module.exports = function getResource(label, vars = []) {
    const resources = {
        found: 'Nous trouvons votre',
        color: 'Couleur:',
        sorry: 'Désolé, nous n’avons pas trouvé de teinte correspondante pour vous.',
        reviewShades: 'Continuer de chercher les teintes disponibles pour',
        selectShade: 'Sélectionner cette teinte',
        done: 'Terminé',
        closest: 'correspondance la plus proche',
        exact: 'correspondance exacte',
        seeAllProducts: 'Voir tous les produits en cette teinte',
        foundMultiShade: 'Nous avons trouvé votre teinte',
        products: 'produits',
        serverErrorMessage: 'Oups! Un problème est survenu.',
        serverErrorAction: 'Cliquez ci-dessus pour trouver votre teinte de nouveau.',
        apiErrorMessage: 'Nous n’avons pas trouvé de résultats...',
        apiErrorAction: 'Veuillez cliquer ci-dessus pour trouver votre teinte de nouveau.',
        queryParamsErrorMessage: 'Bienvenue à l’outil Trouver une teinte',
        queryParamsErrorAction: 'Cliquez ci-dessus pour trouver le fond de teint qui vous convient.',
        saveBeautyPrefsModalTitle: 'Enregistrer dans vos préférences beauté',
        saveBeautyPrefsModalMessage: 'Voulez-vous enregistrer cette teinte dans vos préférences beauté?',
        saveBeautyPrefsModalButton: 'Enregistrer',
        saveBeautyPrefsModalButtonSignIn: 'Ouvrir une session pour enregistrer',
        saveBeautyPrefsModalCancelButton: 'Ne pas enregistrer',
        yourBeautyPrefsModalTitle: 'Vos préférences beauté',
        yourBeautyPrefsModalMessage: 'Nous vous avons facilité la tâche! Vous pouvez maintenant magasiner avec des filtres personnalisés enregistrés.',
        yourBeautyPrefsModalButton: 'Compris',
        yourBeautyPrefsModalCancelButton: 'Modifier les préférences beauté',
        beautyPrefsSavedModalTitle: 'Préférences beauté enregistrées',
        beautyPrefsSavedModalMessage: 'Vos préférences ont été enregistrées.',
        beautyPrefsSavedModalButton: 'Compris',
        beautyPrefsSavedModalCancelButton: 'Modifier les préférences beauté',
        beautyPrefsSaveErrorModalTitle: 'Modifications non enregistrées',
        beautyPrefsSaveErrorModalMessage: 'Un problème est survenu lors du traitement de votre soumission. Veuillez essayer de nouveau.',
        beautyPrefsSaveErrorModalButton: 'Réessayer'
    };

    return resources[label];
};
